import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { FormItemProps, InputProps } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import cl from 'classnames'
import omit from 'lodash/omit'

import { TextArea } from 'Shared/atoms'
import { hasError } from 'Shared/utils/validation'

import { FieldNameRegexType } from 'Core/interfaces'

import FormItem from './FormItem'

import styles from './input.module.scss'

type FormInputProps<FieldsType extends FieldValues> = InputProps &
	FormItemProps &
	TextAreaProps & {
		wrapperClassName?: string
		control: Control<FieldsType>
		fieldName: keyof FieldsType | FieldNameRegexType
		validate?: boolean
		isReadOnly?: boolean
	}

function FormTextArea<FieldsType extends FieldValues>({
	extra,
	label,
	wrapperClassName,
	control,
	validate,
	fieldName,
	...props
}: FormInputProps<FieldsType>) {
	const updatedProps = props.isReadOnly ? omit(props, 'placeholder') : props

	return (
		<Controller
			name={fieldName as FieldPath<FieldsType>}
			control={control}
			render={({ field, fieldState: { error } }) => (
				<FormItem
					className={cl(styles.inputWrapper, wrapperClassName)}
					label={label}
					colon={false}
					name={field.name}
					error={hasError(error)}
					extra={extra}
					validate={validate}
				>
					<TextArea {...updatedProps} {...field} />
				</FormItem>
			)}
		/>
	)
}

export default FormTextArea
